import React from 'react'

import Base from '../_Base'

const IndiaA = (props) => (
  <Base width="29" height="22" viewBox="0 0 29 22" fill="none" {...props}>
    <path
      d="M26.6036 0C27.8511 0.000169362 28.7943 1.12999 28.5714 2.35742L25.2979 20.3574C25.125 21.3084 24.2967 22 23.3302 22H2.39656C1.14884 22 0.205758 20.8702 0.428784 19.6426L3.70124 1.64258C3.87415 0.691597 4.70245 0 5.66902 0H26.6036Z"
      fill="#4A4E58"
      fillOpacity="0.7"
    />
    <path
      d="M11.1102 16.5H9.14149L14.4163 6.31818H16.6933L18.5925 16.5H16.6237L15.2565 8.40625H15.177L11.1102 16.5ZM11.8361 12.5078H17.2054L16.9568 13.9893H11.5875L11.8361 12.5078Z"
      fill="#BBBBBB"
    />
  </Base>
)

export default IndiaA
